import * as React from 'react';

import Modal from 'antd/lib/modal';
import {Field, Form, Formik, FormikProps} from 'formik';

import CustomFile from '@common/react/components/Forms/Files/File';
import {List} from '@common/typescript/objects/List';
import {FileInterface, FileType} from '@common/typescript/objects/FileInterface';

import CustomInput from '@app/components/UI/CustomInput/CustomInput';
import CustomAutoComplete from '@app/components/Forms/CustomAutoComplete/CustomAutoComplete';
import {rest} from '@app/components/Api';

import {StatesListItem} from '@app/objects/StatesListItem';
import {StateListOption} from '@app/objects/SidebarProps';

import '@app/scss/localCommon/components/attachment.scss';

const options_1 = [
	{ value: 'Burns Bay Road' },
	{ value: 'Downing Street' },
	{ value: 'Wall Street' },
];

const employmentOptions = [
	{ value: 'Full-time' },
	{ value: 'Part-time' }
];

const JobInquiryModal = ({modalVisible, setModalVisible}) => {
	const [stateList, setStateList] = React.useState<StatesListItem[]>([]);
	const [resume, setResume] = React.useState<FileInterface>();

	React.useEffect(() => {
		rest.get<List<StatesListItem>>('v1/states').then(res => setStateList(res.list));
	}, []);

	const stateListOptions: StateListOption[] = [];

	const transformStateList = () => {
		stateList && stateList.map((item, index) => {
			stateListOptions.push({value: item.name});
		});
	};

	transformStateList();

	return(
		<Modal
			wrapClassName="modal-wrap job-inquiry"
			visible={modalVisible}
			onOk={() => setModalVisible(false)}
			onCancel={() => setModalVisible(false)}
			width={1037}
		>
			<div className="job-inquiry__content">
				<div className="modal-wrap__container">
					<h3 className="job-inquiry-title">
						Job inquiry
					</h3>
					<Formik
						onSubmit={values => console.log(values)}
						initialValues={{firstName: '', lastName: ''}}
						render={(formikBag: FormikProps<any>) => {
							return (
								<Form className="job-inquiry__form">
									<CustomInput
										type="text"
										name="firstName"
										placeholder="First Name"
										formikBag={formikBag}
									/>
									<CustomInput
										type="text"
										name="lastName"
										placeholder="Last Name"
										formikBag={formikBag}
									/>
									<CustomInput
										type="email"
										name="email"
										placeholder="Email Address"
										formikBag={formikBag}
									/>
									<CustomInput
										type="tel"
										name="phoneNumber"
										placeholder="Phone Number"
										formikBag={formikBag}
									/>
									<CustomInput
										type="number"
										name="zipCode"
										placeholder="Zip code of residence"
										formikBag={formikBag}
									/>
									<CustomInput
										type="text"
										name="city"
										placeholder="City of residence"
										formikBag={formikBag}
									/>
									<Field
										name="stateResidence"

										render={(field) => {
											return(
												// @ts-ignore
												<div className={'custom-field'}>
													<CustomAutoComplete
														placeholder="State of residence"
														// @ts-ignore
														options={stateListOptions}
														// @ts-ignore
														formikBag={formikBag}
														field={field}
														// @ts-ignore
														onSelect = {(value, option) => {
															formikBag.setFieldValue(field.field.name, value);
														}}
														onChange={(value) => {
															formikBag.setFieldValue(field.field.name, value);
														}}
													/>
												</div>
											);
										}}
									/>
									<Field
										name="stateMove"

										render={(field) => {
											return(
												// @ts-ignore
												<div className={'custom-field'}>
													<CustomAutoComplete
														placeholder="State to move"
														// @ts-ignore
														options={stateListOptions}
														// @ts-ignore
														formikBag={formikBag}
														field={field}
														// @ts-ignore
														onSelect = {(value, option) => {
															formikBag.setFieldValue(field.field.name, value);
														}}
														onChange={(value) => {
															formikBag.setFieldValue(field.field.name, value);
														}}
													/>
												</div>
											);
										}}
									/>
									<Field
										name="source"

										render={(field) => {
											return(
												// @ts-ignore
												<div className={'custom-field'}>
													<CustomAutoComplete
														placeholder="How did you hear about us?"
														// @ts-ignore
														options={options_1}
														// @ts-ignore
														formikBag={formikBag}
														field={field}
														// @ts-ignore
														onSelect = {(value, option) => {
															formikBag.setFieldValue(field.field.name, value);
														}}
														onChange={(value) => {
															formikBag.setFieldValue(field.field.name, value);
														}}
													/>
												</div>
											);
										}}
									/>
									<Field
										name="employment"

										render={(field) => {
											return(
												// @ts-ignore
												<div className={'custom-field'}>
													<CustomAutoComplete
														placeholder="Employment Option"
														// @ts-ignore
														options={employmentOptions}
														// @ts-ignore
														formikBag={formikBag}
														field={field}
														// @ts-ignore
														onSelect = {(value, option) => {
															formikBag.setFieldValue(field.field.name, value);
														}}
														onChange={(value) => {
															formikBag.setFieldValue(field.field.name, value);
														}}
													/>
												</div>
											);
										}}
									/>
									<div className="attachment">
										<h4 className="attachment-title">
											Attach a resume
										</h4>
										<div>
											{resume ? <div>{resume.name}</div> : <></>}
										</div>
										<CustomFile update={(data) => { setResume(data); }} type="jobInquiry" fileType={FileType.File} noRelation={true}
											asButton buttonClassName="btn btn-secondary" buttonCaption="Upload a file"/>
										<button type="submit" className="btn btn-primary btn-md">
											Submit your application
										</button>
									</div>
								</Form>
							);
						}}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default JobInquiryModal;